import React from "react";
import { Link, useLocation } from "react-router-dom";
const buttons = [
  {
    id: 1,
    title: "Bookmarks",
    status: true,
  },
  {
    id: 2,
    title: "Sprint plan",
    status: true,
  },
  {
    id: 3,
    title: "Refer & Earn",
    status: true,
  },
];

const Header = ({ title ,role}) => {
  return (
    <header className="bg-white shadow w-full">
      {role==="ROLE_NORMAL"?<div className="max-w-6xl mx-auto py-4 px-6  sm:px-6 h-[70px] lg:px-8 bg-white ">
        {title === "Today's Schedule" ? (
          <div>
            <Link
              to={"https://www.masaischool.com/referral/"}
              className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-[12px] text-white uppercase tracking-[.15em] hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900  focus:ring
           focus:ring-gray-300 disabled:opacity-25 transition float-right "
            >
              Refer & Earn
            </Link>
            <Link
              to={"https://lookerstudio.google.com/embed/u/0/reporting/eb648c7e-0ebe-4ace-be9f-05f85449c32a/page/QHo9C"}
              className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-[12px] text-white uppercase tracking-[.15em] hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900  focus:ring
           focus:ring-gray-300 mr-4 disabled:opacity-25 transition float-right"
            >
              Sprint Plan
            </Link>
            <Link
              to={"/bookmark"}
              className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-[12px] text-white uppercase tracking-[.15em] hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900  focus:ring
           focus:ring-gray-300 disabled:opacity-25 transition float-right  mr-4"
            >
              Bookmarks
            </Link>
          </div>
        ) : (
          ""
        )}
        <h2 className="inline-flex items-center  font-semibold text-[20px] text-[#414141] leading-tight   float-left">
          {title}
        </h2>
      </div>:title=="Bookmark"?<div className="max-w-6xl mx-auto py-4 px-6  sm:px-6 h-[70px] lg:px-8 bg-white ">
      <h2 className="inline-flex items-center  font-semibold text-[20px] text-[#414141] leading-tight   float-left">
          {title}
        </h2>
        <Link
              to={"https://www.masaischool.com/referral/"}
              className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-[12px] text-white uppercase tracking-[.15em] hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900  focus:ring
           focus:ring-gray-300 disabled:opacity-25 transition float-right "
            >
              Refer & Earn
            </Link>
        </div>:<div className="max-w-6xl mx-auto py-4 px-6  sm:px-6 h-[70px] lg:px-8 bg-white ">
      <h2 className="inline-flex items-center  font-semibold text-[20px] text-[#414141] leading-tight   float-left">
          Lecture
        </h2>
        
        </div>}
    </header>
  );
};

export default Header;
